import { render } from "./review-modal.vue?vue&type=template&id=4d5eb7b9&scoped=true"
import script from "./review-modal.vue?vue&type=script&lang=js"
export * from "./review-modal.vue?vue&type=script&lang=js"

import "./review-modal.vue?vue&type=style&index=0&id=4d5eb7b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5eb7b9"]])

export default __exports__